<div class="recentSearchSlider">
  <div #sectionSlideSearch class="recentSearchSlider__wrapper">
    <div class="recentSearchSlider__buffer">
      <div class="recentSearchSlider__slider">
        <ng-container *ngFor="let search of searches; index as id; trackBy: trackById">
          <div #slideRecentSearch>
            <ng-container [ngSwitch]="search.datatype">
              <ng-container *ngSwitchCase="recentSearchDataType.Flight">
                <app-air-recent-search
                  [search]="search"
                  [isMobile]="isMobile"
                  [dataType]="search.datatype"
                  [id]="id">
                </app-air-recent-search>
              </ng-container>
              <ng-container *ngSwitchCase="recentSearchDataType.Cars">
                <app-cars-recent-search
                  [search]="search"
                  [isMobile]="isMobile"
                  [dataType]="search.datatype"
                  [id]="id">
                </app-cars-recent-search>
              </ng-container>
              <ng-container *ngSwitchCase="recentSearchDataType.Hotel">
                <app-hotel-recent-search
                  [search]="search"
                  [isMobile]="isMobile"
                  [dataType]="search.datatype"
                  [id]="id">
                </app-hotel-recent-search>
              </ng-container>
              <ng-container *ngSwitchCase="recentSearchDataType.Bus">
                <app-bus-recent-search
                  [search]="search"
                  [isMobile]="isMobile"
                  [dataType]="search.datatype"
                  [id]="id">
                </app-bus-recent-search>
              </ng-container>
              <ng-container *ngSwitchCase="recentSearchDataType.Packages">
                <app-air-package-recent-search
                  [search]="search"
                  [isMobile]="isMobile"
                  [dataType]="search.datatype"
                  [id]="id">
                </app-air-package-recent-search>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!isMobile">
    <app-ds-button-icon
      *ngIf="showl"
      class="recentSearchSlider__buttons recentSearchSlider__buttons--previous" 
      [type]="buttonType"
      [icon]="icon.ChevronLeft"
      [buttonSize]="buttonIconSize"
      [iconSize]="20"
      (click)="previous()">
    </app-ds-button-icon>
    <app-ds-button-icon
      *ngIf="showr"
      class="recentSearchSlider__buttons recentSearchSlider__buttons--next" 
      [type]="buttonType"
      [icon]="icon.ChevronRight"
      [buttonSize]="buttonIconSize"
      [iconSize]="20"
      (click)="next()">
    </app-ds-button-icon>
  </ng-container>
</div>